import './App.css';
import { Routes, Route } from "react-router-dom"
import { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import Home from './pages/home/Home';
import Blog from './pages/blog/Blog';
import BlogPost from './pages/blog/BlogPost';
import Portfolio from './pages/portfolio/Portfolio';

import { ThemeProvider } from '@mui/material/styles';
import { darkTheme, lightTheme } from './Theme';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import { CssBaseline, Box } from '@mui/material';

function App() {
  const [themeMode, setThemeMode] = useState('dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('themeMode') || 'dark';
    setThemeMode(savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = themeMode === 'dark' ? 'light' : 'dark';
    setThemeMode(newTheme);
    localStorage.setItem('themeMode', newTheme);
  };

  return (
    <HelmetProvider>
    <ThemeProvider theme={themeMode === 'dark' ? darkTheme : lightTheme}>
      <CssBaseline />

      {/* Background container */}
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 0, sm: 3 },
          backgroundColor: 'background.default',
        }}
      >
        {/* Main card container */}
        <Box
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: 1000 },
            height: { xs: '100vh', sm: '85vh' },
            backgroundColor: 'background.paper',
            boxShadow: { xs: 'none', sm: '0 8px 32px rgba(0, 0, 0, 0.4)' },
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* Header inside card */}
          <Header themeMode={themeMode} toggleTheme={toggleTheme} />

          {/* Content area */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Blog />} />
                <Route path="/about" element={<Home />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/portfolio" element={<Portfolio />} />
              </Routes>
            </Box>

            {/* Footer inside card */}
            <Footer />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
